/**
 * Copyright (C) SiteVision AB 2002-2026, all rights reserved
 */
import { hasPortlet } from '../../util/findPortlets';

if (hasPortlet('sv-searchform-portlet')) {
  import(/* webpackChunkName: "searchForm" */ './searchForm').then(
    ({ initSearchForm }) => {
      document
        .querySelectorAll('.sv-searchform-portlet')
        .forEach(initSearchForm);
    },
  );
}
